import { forwardRef } from "react";
import { MaskedInput, type MaskedInputProps } from "./MaskedInput";
import { formatPhone } from "../../lib/format";

export type PhoneInputProps = Omit<MaskedInputProps, "mask">;

export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  function PhoneInput(props, ref) {
    return (
      <MaskedInput
        ref={ref}
        inputMode="tel"
        autoComplete="tel"
        placeholder="(00) 00000-0000"
        mask={formatPhone}
        {...props}
      />
    );
  }
);
